<script setup lang="ts">
interface MobileStickyButtonData {
  Enabled?: boolean
  Label?: string
  Link?: string
}

defineProps<{
  button?: MobileStickyButtonData | null
}>()
</script>

<template>
  <div
    v-if="button?.Enabled && button?.Label && button?.Link"
    class="mobile-sticky-button"
  >
    <AppLink
      :to="button.Link"
      class="mobile-sticky-button__link"
    >
      {{ button.Label }}
    </AppLink>
  </div>
</template>

<style>
@import url("~layers/app/components/Slices/MobileStickyButton.css");
</style>
